
import Header from "../Components/Header"

import Footer from "../Components/Footer";
import CommonLanding from "../Components/CommonLanding";
import "swiper/css";
import "swiper/css/navigation";

export default function FamilyPartyLanding() {
  return (
    <>

    <CommonLanding
      title="Private Yacht Parties for Your Inner Circle"
      subtitle="Quality time, away from the crowd"
      heading="Relax, Celebrate & Enjoy Privacy"
      text="Perfect for families and friends. Enjoy private yacht experiences without crowds."
      image="https://images.unsplash.com/photo-1507525428034-b723cf961d3e"
      ctaText="Book Now"
      schema={{
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": "Private Yacht Rental"
      }}
      features={[
        { title: "Small Groups", desc: "2–15 guests." },
        { title: "Kid Friendly", desc: "Safe environment." },
        { title: "Flexible Time", desc: "2 hrs to full day." }
      ]}
    />
      <Header />

      <section className="ib-bday-wrapper">
        <div className="ib-bday-hero">
          <h1 className="ib-bday-title">
            Private Yacht Parties for Your Inner Circle
          </h1>
          <p className="ib-bday-subtitle">
            Quality time, away from the city noise.
          </p>
        </div>

        <div className="ib-bday-section">
          <h2 className="ib-bday-heading">
            Relax, Celebrate & Enjoy Privacy
          </h2>
          <p className="ib-bday-text">
            Perfect for families and close friends. No crowds, just your people and the sea.
          </p>
        </div>

        <div className="ib-bday-feature-grid">
          <div className="ib-bday-card">
            <h3>Small Group Friendly</h3>
            <p>Ideal for 2–15 guests.</p>
          </div>

          <div className="ib-bday-card">
            <h3>Kid Safe</h3>
            <p>Safety-first setup for families.</p>
          </div>

          <div className="ib-bday-card">
            <h3>Flexible Timing</h3>
            <p>2-hour to full-day options.</p>
          </div>
        </div>

        <div className="ib-bday-cta">
          <a href="/contact" className="ib-bday-btn">
            Book Now
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
}
